import { twMerge } from 'tailwind-merge';

interface DimProps {
  className?: string;
}

export const Dim = ({ className }: DimProps) => (
  <div className={twMerge('absolute inset-0 bg-zinc-500/50', className)} />
);
